import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { bariPreNurseSpecialistMedScreeningReportReadSchemaV1 } from './v1/bariPreNurseSpecialistMedScreeningReportReadSectionsV1';
import {
    bariPreNurseSpecialistMedScreeningReportDraftSchemaV1,
    bariPreNurseSpecialistMedScreeningReportFinalSchemaV1,
} from './v1/bariPreNurseSpecialistMedScreeningReportSchemaV1';
import { bariPreNurseSpecialistMedScreeningReportReadSchemaV2 } from './v2/bariPreNurseSpecialistMedScreeningReportReadSectionsV2';
import {
    bariPreNurseSpecialistMedScreeningReportDraftSchemaV2,
    bariPreNurseSpecialistMedScreeningReportFinalSchemaV2,
} from './v2/bariPreNurseSpecialistMedScreeningReportSchemaV2';

const customControlCode = CustomControlCode.BariPreNurseSpecialistMedScreeningReport;

ServiceActivityRegistry.instance.registerAll([
    {
        customControlCode,
        draft: bariPreNurseSpecialistMedScreeningReportDraftSchemaV1,
        final: bariPreNurseSpecialistMedScreeningReportFinalSchemaV1,
        readSections: bariPreNurseSpecialistMedScreeningReportReadSchemaV1,
        version: 1,
    },
    {
        customControlCode,
        draft: bariPreNurseSpecialistMedScreeningReportDraftSchemaV2,
        final: bariPreNurseSpecialistMedScreeningReportFinalSchemaV2,
        readSections: bariPreNurseSpecialistMedScreeningReportReadSchemaV2,
        version: 2,
    },
]);
